import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ViacepType } from '../interfaces/viacep';
import { ServerUrlService } from './server-url.service';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {

  constructor(private serverUrl: ServerUrlService, private httpClient: HttpClient) { }

  public textToSpeech(text: string): string {
    return `${this.serverUrl.getUrl()}/tools/text-to-speech/${text}`
  }

  public searchCEP(cep: number): Observable<ViacepType> {
    return (this.httpClient.get(`https://viacep.com.br/ws/${cep}/json/`) as (Observable<ViacepType>) )
  }

}
